var _rect, _rect2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpaceThumbnail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 102,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "#2D3D53",
    stroke: "#1E1E1E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90.6572,
    cy: 22,
    r: 3,
    fill: "#8BA2C0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.2335,
    cy: 82.9115,
    r: 2.12955,
    transform: "rotate(135 28.2335 82.9115)",
    fill: "#8BA2C0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.1572,
    cy: 67.5,
    r: 4.5,
    fill: "#8BA2C0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.975,
    cy: 46.364,
    r: 3.05328,
    transform: "rotate(135 26.975 46.364)",
    fill: "#8BA2C0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.6572,
    cy: 13,
    r: 2,
    fill: "#8BA2C0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.6571,
    cy: 61.5858,
    r: 1,
    transform: "rotate(135 58.6571 61.5858)",
    fill: "#8BA2C0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.4139,
    cy: 30.5858,
    r: 1,
    transform: "rotate(135 49.4139 30.5858)",
    fill: "#8BA2C0"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.4139,
    cy: 96.5858,
    r: 1,
    transform: "rotate(135 13.4139 96.5858)",
    fill: "#8BA2C0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.078,
    cy: 78.1765,
    r: 1,
    transform: "rotate(-165 69.078 78.1765)",
    fill: "#8BA2C0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.3036,
    cy: 54.6721,
    r: 1,
    transform: "rotate(-165 91.3036 54.6721)",
    fill: "#8BA2C0"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1464,
    cy: 56.4952,
    r: 1,
    transform: "rotate(-165 16.1464 56.4952)",
    fill: "#8BA2C0"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.4851,
    cy: 15.8284,
    r: 2,
    transform: "rotate(135 19.4851 15.8284)",
    fill: "#8BA2C0"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.485,
    cy: 94.8284,
    r: 2,
    transform: "rotate(135 76.485 94.8284)",
    fill: "#8BA2C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6087 70.1805C31.3385 71.4445 31.8171 72.76 32.0148 74.2377C32.1719 75.6452 32.1481 77.0635 31.7622 78.5035C31.6732 78.8358 31.5841 79.1681 31.4545 79.4302C31.2359 80.0246 30.9767 80.5488 30.6473 81.1135C30.4178 81.5269 30.1883 81.9403 29.9183 82.2835C29.7481 82.4754 29.578 82.6672 29.4079 82.8591C29.0676 83.2428 28.7273 83.6266 28.2763 83.9806C27.755 84.3752 27.304 84.7292 26.7422 85.0536L21.2685 75.573L15.7949 66.0924C16.3567 65.768 16.8889 65.5545 17.4912 65.3003C17.9531 65.1273 18.5258 64.9839 19.0283 64.8811C19.2795 64.8297 19.5307 64.7783 19.7819 64.7269C20.2142 64.6646 20.6869 64.6725 21.1597 64.6805C21.8135 64.6776 22.397 64.7152 23.0211 64.8231C23.3534 64.9121 23.6452 64.9309 23.9775 65.02C25.3473 65.4464 26.6577 66.0943 27.7981 66.9341C28.9789 67.8442 29.8789 68.9164 30.6087 70.1805Z",
    fill: "#F1AE5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83342 42.9415L7.20429 40.9953C8.81951 40.0628 18.0411 44.1958 22.021 45.7371C22.6154 45.9558 25.73 45.1875 27.6696 44.8168C28.4935 44.622 29.4093 44.7487 30.1254 45.178L36.1643 48.3396L17.8243 58.7409L3.72847 44.2193C3.3042 43.8088 3.41206 43.1848 3.83342 42.9415Z",
    fill: "#EA462F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.569 48.0784C92.6233 48.9833 92.5263 49.7884 92.3591 50.6341C91.8169 53.1007 77.3452 62.5796 75.1682 63.8365L38.2398 85.3444L21.6162 56.5515L46.0551 42.4417C62.8559 34.2399 80.7032 37.4192 82.9483 37.9021C83.0591 37.9318 83.2806 37.9911 83.3914 38.0208C84.3587 38.3987 85.2854 38.7064 86.0717 39.0952C90.9406 41.5277 92.4249 45.0716 92.569 48.0784Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0282 64.8811L29.4484 82.9293C29.1081 83.313 28.7679 83.6968 28.3168 84.0508L17.4912 65.3003C18.0233 65.0867 18.5258 64.9839 19.0282 64.8811Z",
    fill: "#F75322"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6457 64.9309L31.7547 78.9763C31.5361 79.5707 31.2769 80.0948 31.0177 80.619L21.8545 64.7478C22.438 64.7854 23.0216 64.8231 23.6457 64.9309Z",
    fill: "#F75322"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3173 71.2563L38.4838 85.7657L33.2939 76.7767C33.2939 76.7767 72.1793 58.8207 87.3308 46.1403C87.3308 46.1403 92.1382 50.5747 92.3598 50.634C92.3598 50.634 92.6582 54.3945 62.5686 71.2049",
    fill: "#B9BEC6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9154 86.8265L57.5244 72.5249L55.7941 76.9883C55.6349 77.3612 48.1749 82.6045 47.9346 82.837L42.9877 90.0003C42.7176 90.3435 42.4476 90.6866 42.0262 90.9299C39.9006 92.438 32.4595 97.3896 32.5377 96.8763L32.9154 86.8265Z",
    fill: "#EA462F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5998 66.5038L36.0014 68.004C35.3694 68.3689 34.594 68.1612 34.2291 67.5291L33.5804 66.4055C33.2155 65.7734 33.4232 64.998 34.0553 64.6331L36.6537 63.133C37.2857 62.768 38.0611 62.9758 38.426 63.6079L39.0747 64.7315C39.4396 65.3635 39.2319 66.1389 38.5998 66.5038Z",
    fill: "#67717E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3772 61.4357L44.7788 62.9358C44.1467 63.3007 43.3713 63.093 43.0064 62.4609L42.3577 61.3373C41.9928 60.7053 42.2006 59.9299 42.8326 59.565L45.431 58.0648C46.063 57.6999 46.8384 57.9076 47.2033 58.5397L47.8521 59.6633C48.217 60.2953 48.0092 61.0707 47.3772 61.4357Z",
    fill: "#67717E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2258 56.327L53.6274 57.8271C52.9954 58.192 52.22 57.9843 51.8551 57.3522L51.2063 56.2286C50.8414 55.5966 51.0492 54.8212 51.6812 54.4563L54.2796 52.9561C54.9117 52.5912 55.6871 52.7989 56.052 53.431L56.7007 54.5546C57.0656 55.1866 56.8578 55.962 56.2258 56.327Z",
    fill: "#67717E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.569 48.0784C92.6233 48.9833 92.5263 49.7884 92.3591 50.6341C90.3435 49.7378 88.5465 48.2471 87.3707 46.2106C86.0732 43.9633 85.6699 41.4807 86.0716 39.0952C90.9406 41.5277 92.4248 45.0716 92.569 48.0784Z",
    fill: "#EA462F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7794 42.384C65.5658 41.8519 65.9763 41.4276 66.3868 41.0033C67.4887 39.9926 68.5363 38.0769 77.2221 39.3357C82.3552 40.1175 74.2792 44.7802 72.6343 45.8236C72.4236 45.9452 72.2426 45.9561 72.0616 45.9669C70.854 45.8214 67.0501 45.3958 65.7794 42.384Z",
    fill: "#67717E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceThumbnail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SpaceThumbnail.d9231244dab2fec62d230510dd4ae706.svg";